"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var superagent_1 = __importDefault(require("superagent"));
exports.calculateLogBufferSize = function (arr) {
    return arr.reduce(function (size, trace) { return size + exports.calculateLogMessageSize(trace); }, 0);
};
exports.calculateLogMessageSize = function (trace) {
    var str = JSON.stringify(trace);
    // http://stackoverflow.com/questions/5515869/string-length-in-bytes-in-javascript
    // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
    var m = encodeURIComponent(str).match(/%[89ABab]/g);
    return str.length + (m ? m.length : 0);
};
exports.requestApi = function (path, reqOpts) {
    var req = superagent_1.default[reqOpts.method || 'get'](buildUri(path, reqOpts.environment, reqOpts.apiVersion));
    if (reqOpts.accessToken) {
        req.set('Authorization', "Bearer " + reqOpts.accessToken);
    }
    req.type(reqOpts.contentType || 'json');
    return req.send(reqOpts.data);
};
var buildUri = function (path, environment, version) {
    if (version === void 0) { version = 'v2'; }
    path = path.replace(/^\/+|\/+$/g, ''); // trim leading/trailing /
    return "https://api." + environment + "/api/" + version + "/" + path;
};
